export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4788.3a3375fe.jpg";